import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getDashboardHistorias,getHistoriaClinicaPorPaciente  } from "../../../services/historiaClinica"; 
import "./DashboardHistoriaClinica.css";
import ModalGestionPacientes from "./ModalGestionPacientes";
import ModalMergePacientes from "./ModalesEdicion/ModalMergePacientes";
import ModalHojaDiaria from "./ModalesEdicion/ModalHojaDiaria";
import { getMedicoAuth } from "../../../services/usuarios";
import ModalArchivoIntercambio from "./ModalesEdicion/ModalArchivoIntercambio";

const DashboardHistoriaClinica = () => {
  const [pacientes, setPacientes] = useState([]); // ✅ Inicializar con un array vacío
  const [searchText, setSearchText] = useState(""); 
  const navigate = useNavigate(); 
  const [openGestionPacientes, setOpenGestionPacientes] = useState(false);
  const [openMergePacientes, setOpenMergePacientes] = useState(false);
  const [openAdvancedMenu, setOpenAdvancedMenu] = useState(false);
  const [openHojaDiaria, setOpenHojaDiaria] = useState(false);
  const [openArchivoIntercambio, setOpenArchivoIntercambio] = useState(false);
  const [medico, setMedico] = useState(null);
  
  useEffect(() => {
  const fetchMedico = async () => {
    try {
      const data = await getMedicoAuth();
      setMedico(data);
    } catch (error) {
      console.error("Error cargando médico para hoja diaria:", error);
    }
  };

  fetchMedico();
}, []);
  // ✅ Cargar pacientes desde el backend al montar el componente
  useEffect(() => {
    const fetchPacientes = async () => {
      try {
        const soloActivos = await getDashboardHistorias();
  
        const pacientesActualizados = soloActivos.map((item) => {

          const paciente = item.paciente;
         
          const historia = item.historia;
          const consultas = item.consultas || [];
  
            let ultimaConsulta = "No registrada";
            const fechas = [];
  
            // 🔹 Usar fecha de historia clínica tal cual (ya está en local)
            if (historia?.fecha_consulta) {
              const fechaHistoria = new Date(historia.fecha_consulta);
              if (!isNaN(fechaHistoria)) {
                
                fechas.push(fechaHistoria);
              }
            }
  
            // 🔹 Convertir fechas de consultas desde UTC a CDMX
            if (Array.isArray(consultas) && consultas.length > 0) {
              
              consultas.forEach((consulta, i) => {
                
                if (consulta.fecha_consulta) {
                  const fechaConvertida = new Date(
                    new Date(consulta.fecha_consulta).toLocaleString("en-US", {
                      timeZone: "America/Mexico_City",
                    })
                  );
                  if (!isNaN(fechaConvertida)) {
                    fechas.push(fechaConvertida);
                  }
                }
              });
            }
  
            // 🔹 Obtener la fecha más reciente
            const fechasValidas = fechas.filter((f) => f instanceof Date && !isNaN(f));
            const fechaMasReciente = fechasValidas.length
              ? new Date(Math.max(...fechasValidas.map((f) => f.getTime())))
              : null;
  
            if (fechaMasReciente) {
              ultimaConsulta = fechaMasReciente.toLocaleDateString("es-MX", {
                timeZone: "America/Mexico_City",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              });
              
            }
  
           return {
            ...paciente,
            historia,
            consultas,
            ultimaConsulta,
            tipo_paciente: paciente.tipo_paciente || "Registrado",
          };
         });
  
        setPacientes(pacientesActualizados);
      } catch (error) {
        console.error("Error cargando pacientes:", error);
      }
    };
  
    fetchPacientes();
  
    const handleMessage = (event) => {
      if (event.data?.type === "refreshPacientes") {
        fetchPacientes();
      }
    };
  
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  

  const handleAgregarPaciente = () => {
    navigate("/dashboard/alta-paciente"); 
  };

  const handleIniciarConsulta = async (pacienteId) => {
    try {
        // 🔹 Obtener la historia clínica del paciente usando el endpoint correcto
        const historiaClinica = await getHistoriaClinicaPorPaciente(pacienteId);
      
        
        // ✅ Validamos si existe historia clínica 
        if (!historiaClinica || !historiaClinica.id) {
           
            navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
            return;
        }
        
      
        
        // 🔹 Verificar si la historia tiene fecha de consulta registrada
        if (historiaClinica.fecha_consulta) {
            navigate(`/dashboard/consulta-seguimiento/${pacienteId}`);
        } else {
            // 🔹 Si la historia existe pero no tiene fecha de consulta, se manda a Alta Historia Clínica
            navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
        }
    } catch (error) {
        console.error("Error al obtener historia clínica:", error);
        // Si el error es 404 (no encontrado), redirigir a alta de historia clínica
        if (error.response && error.response.status === 404) {
          
            navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
        } else {
            alert("No se pudo obtener la historia clínica. Intenta de nuevo.");
        }
    }
};
  const getIdSalvir = (pacienteId) => {
  return pacienteId ? pacienteId.slice(-5).toUpperCase() : "—";
};

  // Filtrar pacientes según búsqueda
const filteredPacientes = pacientes.filter((p) => {
  const q = (searchText || "").toLowerCase();

  const nombre = [p?.nombre, p?.apellido_paterno, p?.apellido_materno]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  const curp = (p?.curp || "").toLowerCase();
  const idSalvir = getIdSalvir(p?.id).toLowerCase();

  return nombre.includes(q) || curp.includes(q) || idSalvir.includes(q);
});

  // calculo edad
  const calcularEdad = (fecha_nacimiento) => {
    if (!fecha_nacimiento) return "No registrada"; // Si no hay fecha, mostrar "No registrada"
    
    const hoy = new Date();
    const fechaNac = new Date(fecha_nacimiento);
    let edad = hoy.getFullYear() - fechaNac.getFullYear();
    
    // Ajuste si el cumpleaños aún no ha ocurrido este año
    const mes = hoy.getMonth() - fechaNac.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edad--;
    }
    
    return edad >= 0 ? edad : "No registrada"; // Evita edades negativas si hay error en el dato
  };
  

  return (
    <div className="historia-clinica-layout">
      <h2>Expedientes Clínicos</h2>

      <div className="acciones-expedientes-header">
        <div className="acciones-expedientes-principales">
          <button className="add-patient-button" onClick={handleAgregarPaciente}>
            Agregar Paciente
          </button>
        </div>

        <div className="acciones-expedientes-avanzadas">
          <button
            className="advanced-actions-button"
            onClick={() => setOpenAdvancedMenu(!openAdvancedMenu)}
            title="Opciones de pacientes"
          >
            ⚙️
          </button>

          {openAdvancedMenu && (
            <div className="advanced-actions-menu">
              <button
                className="advanced-actions-menu-item"
                onClick={() => {
                  setOpenGestionPacientes(true);
                  setOpenAdvancedMenu(false);
                }}
              >
                Archivar pacientes
              </button>

              <button
                className="advanced-actions-menu-item"
                onClick={() => {
                  setOpenMergePacientes(true);
                  setOpenAdvancedMenu(false);
                }}
              >
                Fusionar pacientes
              </button>
              <button
                className="advanced-actions-menu-item"
                onClick={() => {
                  setOpenHojaDiaria(true);
                  setOpenAdvancedMenu(false);
                }}
              >
                Exportar hoja diaria
              </button> 
              <button
                className="advanced-actions-menu-item"
                onClick={() => {
                  setOpenArchivoIntercambio(true);
                  setOpenAdvancedMenu(false);
                }}
              >
                Exportar archivo de intercambio
              </button>
            </div>
          )}
        </div>
      </div>

      <input
        type="text"
        placeholder="Buscar por nombre, CURP o ID Salvir"
        className="search-bar"
        value={searchText} 
        onChange={(e) => setSearchText(e.target.value)} 
      />

      <div className="pacientes-list">
  <div className="pacientes-table-header">
    <div>ID Salvir</div>
    <div>Paciente</div>
    <div>Edad</div>
    <div>Última consulta</div>
    <div>Tipo de paciente</div>
    <div>Acciones</div>
  </div>

  {filteredPacientes.length > 0 ? (
    filteredPacientes.map((paciente) => (
      <div
          key={paciente.id}
          className="paciente-item"
          onClick={() => navigate(`/dashboard/paciente/${paciente.id}`)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              navigate(`/dashboard/paciente/${paciente.id}`);
            }
          }}
        >
        <div className="paciente-col paciente-id-col">
          {getIdSalvir(paciente.id)}
        </div>

        <div className="paciente-col paciente-nombre-col">
          {`${paciente.nombre} ${paciente.apellido_paterno || ""} ${paciente.apellido_materno || ""}`.trim()}
        </div>

        <div className="paciente-col paciente-edad-col">
          {calcularEdad(paciente.fecha_nacimiento) !== "No registrada"
            ? `${calcularEdad(paciente.fecha_nacimiento)} años`
            : "No registrada"}
        </div>

        <div className="paciente-col paciente-ultima-col">
          {paciente.ultimaConsulta || "No registrada"}
        </div>

        <div className="paciente-col paciente-tipo-col">
          {paciente.tipo_paciente || "Registrado"}
        </div>

        <div className="paciente-col paciente-actions">
         <button
            className="start-consultation-button"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/dashboard/paciente/${paciente.id}`);
            }}
          >
            Ver Expediente
          </button>

                  <button
            className="start-consultation-button"
            onClick={(e) => {
              e.stopPropagation();
              handleIniciarConsulta(paciente.id);
            }}
          >
            Iniciar Consulta
          </button>
        </div>
      </div>
    ))
  ) : (
    <p>No hay pacientes registrados o no coinciden con la búsqueda.</p>
  )}
</div>
            
       {openGestionPacientes && (
         <ModalGestionPacientes
          isOpen={openGestionPacientes}
           onClose={() => setOpenGestionPacientes(false)}
          onUpdated={() => window.postMessage({ type: "refreshPacientes" }, "*")}
         />
       )}

       {openMergePacientes && (
        <ModalMergePacientes
          isOpen={openMergePacientes}
          onClose={() => {
            setOpenMergePacientes(false);
            setOpenAdvancedMenu(false);
          }}
          pacientes={pacientes}
          onUpdated={() => window.postMessage({ type: "refreshPacientes" }, "*")}
        />
      )}
      
      {openHojaDiaria && (
  <ModalHojaDiaria
  isOpen={openHojaDiaria}
  onClose={() => setOpenHojaDiaria(false)}
  medico={medico}
/>
)}

{openArchivoIntercambio && (
  <ModalArchivoIntercambio
    isOpen={openArchivoIntercambio}
    onClose={() => setOpenArchivoIntercambio(false)}
  />
)}

    </div>
  );
};

export default DashboardHistoriaClinica;
